/**
 * Characters pinned to the top of the default browse order (main page +
 * catalog default view). Order here = order on screen. Editing this list is
 * all it takes to re-feature; the loader sorts these to the front and leaves
 * everyone else in their normal (newest-first) order.
 */
export const FEATURED_CHARACTER_SLUGS: string[] = [
  'bianca-costa', // Bianca Costa
  'mia-rossi', // Mia Rossi
  'selena-marino', // Selena Marino
  'freya-lindqvist', // Freya Lindqvist
  'sofia-ivanova', // Sofia Ivanova
  'astrid-bergstr-m', // Astrid Bergström
  'valentina-espinoza', // Valentina Espinoza
  'greta-hoffmann', // Greta Hoffmann
  'anna-nowak', // Anna Nowak
  'isabela-de-souza', // Isabela de Souza
  'elsa-andersson', // Elsa Andersson
  'nova-taylor', // Nova Taylor
  'freya-hartmann', // Freya Hartmann
  'aurora-thatcher', // Aurora Thatcher
  'mei-lin', // Mei Lin
  'margot-laurent', // Margot Laurent
  'shirley-wong', // Shirley Wong
  'valeria-popescu', // Valeria Popescu
  'louisa-edelweiss', // Louisa Edelweiss
];

const RANK = new Map(FEATURED_CHARACTER_SLUGS.map((slug, i) => [slug, i]));

/** Lower = higher up. Non-featured characters sort after all featured ones. */
export function featuredRank(slug: string): number {
  return RANK.get(slug) ?? Number.MAX_SAFE_INTEGER;
}
